<div class="row" *ngIf="!is_modal">
    <div class="col-12" style="margin-top: 100px;" >

    </div>
</div>

<section class="">
    <div class="container-xl">
        <div class="row mt-2 justify-content-center">
            <h2 class="text-center dark mb-3 underline">
                Tenant  Plan
            </h2>
            <div class="col-md-4" [ngClass]="!is_modal ? 'card-fit' : 'card-fit-modal'">
                <div class="card">
                    <div class="card-header card-header-first">
                        <div class="row mt-3">
                            <div class="col-8">
                                <p>Standard Plan</p>
                            </div>
                            <div class="col-4">
                                <p class="text">AED 475</p>
                                <!-- <p class="word">+5% VAT</p> -->
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row" *ngFor="let pf of planFeatures.standard.features">
                            <div class="col-9">
                                <p class="bold list">{{pf.label ? pf.label : "&nbsp;"}}</p>
                            </div>
                            <div class="col-3 text-end">
                                <p class="bold list" *ngIf="pf.value">
                                    {{pf.value}}
                                </p>
                                <i  *ngIf="pf.label && !pf.value" class="fa fa-check icon"></i>
                            </div>
                        </div>            
                        <div class="text-center">
                            <button type="button" class="btn subscribe" (click)="onSubmit('1')">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="col-md-4 mb-5" [ngClass]="!is_modal ? 'card-fit' : 'card-fit-modal'">
                <div class="card">
                    <div class="card-header head">
                        <div class="row mt-3">
                            <div class="col-8">
                                <p>Premium Plan</p>
                            </div>
                            <div class="col-4">
                                <p class="text">AED 875</p>
                                <!-- <p class="word">+5% VAT</p> -->
                            </div>
                        </div>
                    </div>
                
                    <div class="card-body">
                        <div class="row" *ngFor="let pf of planFeatures.premium.features">
                            <div class="col-9">
                                <p class="bold list">{{pf.label}}</p>
                            </div>
                            <div class="col-3 text-end">
                                <p class="bold list" *ngIf="pf.value">
                                    {{pf.value}}
                                </p>
                                <i  *ngIf="!pf.value" class="fa fa-check icon"></i>
                            </div>
                        </div>                       
                        <div class="text-center">
                            <button type="button" class="btn subscribe-select" (click)="onSubmit('2')">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

